import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './TopBar.css'

const TopBar = ({ currentStep, totalSteps, showBack = true, onBack, logo }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const progress =
    typeof currentStep === 'number' && typeof totalSteps === 'number' && totalSteps > 0
      ? Math.max(0, Math.min(1, currentStep / totalSteps))
      : null

  const handleBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <div className="top-bar">
      <div className="top-bar-left">
        {showBack ? (
          <button className="back-button" onClick={handleBack} aria-label={t('common.back')}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        ) : (
          <div className="top-bar-spacer" />
        )}
      </div>

      <div className="top-bar-center">
        {progress !== null ? (
          <div className="progress-track" aria-hidden="true">
            <div className="progress-fill" style={{ width: `${progress * 100}%` }} />
          </div>
        ) : (
          <div className="top-bar-spacer" />
        )}
      </div>

      <div className="top-bar-right">
        <div className="logo-icon" aria-label="AstroMatch">
          {logo ? logo : <img src="/Logo.png" alt="AstroMatch Logo" />}
        </div>
      </div>
    </div>
  )
}

export default TopBar

